import { DateTime } from 'luxon';
import { Directive, DirectiveBinding } from 'vue';

function dateTimeFormatter(el: HTMLElement, binding: DirectiveBinding<Date | string>) {
   if (!binding.value) return;

   const date = DateTime.fromJSDate(new Date(binding.value));
   el.innerHTML = date.toFormat('dd/MM/y HH:mm');
}

const DateTimeFormatter: Directive = {
   mounted: dateTimeFormatter,
   updated: dateTimeFormatter,
};

function dateFormatter(el: HTMLElement, binding: DirectiveBinding<Date | string>) {
   if (!binding.value) return;

   const date = DateTime.fromJSDate(new Date(binding.value));
   el.innerHTML = date.toFormat(`dd/MM/y`);
}

const DateFormatter: Directive = {
   mounted: dateFormatter,
   updated: dateFormatter,
};

export { DateTimeFormatter, DateFormatter };
